import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '100%',
    overflowY: 'auto',
    marginTop: '1rem',
    height: '50rem',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginBottom: '1.25rem',
    marginTop: '1rem',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    textDecoration: 'underline',
    color: theme.palette.text.primary,
    width: '30%',
  },
}));

export default useStyles;
